import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ghgChartPeriods, ghgMetricValuesForPeriods } from '~/functions/ghg';
export default /*#__PURE__*/_defineComponent({
  __name: 'GhgChart',
  props: {
    metricValues: Array,
    solutionSeries: Array,
    width: {
      type: Number,
      required: false
    },
    height: {
      type: Number,
      required: false
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var CHART_COLORS = ['#5188ff', '#10b981', '#6366f1', '#f59e0b', '#8b5cf6'];
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var isStacked = computed(function () {
      var _props$solutionSeries, _props$solutionSeries2;
      return ((_props$solutionSeries = (_props$solutionSeries2 = props.solutionSeries) === null || _props$solutionSeries2 === void 0 ? void 0 : _props$solutionSeries2.length) !== null && _props$solutionSeries !== void 0 ? _props$solutionSeries : 0) > 1;
    });
    var isCompact = computed(function () {
      return !!(props.width && props.width < 400);
    });

    /** Apex default is ~350; stacked charts need room for the legend. */
    var chartHeight = computed(function () {
      var _props$height;
      return (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : isStacked.value ? 400 : 350;
    });
    var chartRef = ref();
    var chartPeriods = computed(function () {
      var _props$solutionSeries3, _props$metricValues;
      var fromSolutions = (_props$solutionSeries3 = props.solutionSeries) !== null && _props$solutionSeries3 !== void 0 ? _props$solutionSeries3 : [];
      if (fromSolutions.length) {
        return ghgChartPeriods(fromSolutions, props.metricValues);
      }
      return ghgChartPeriods([], (_props$metricValues = props.metricValues) === null || _props$metricValues === void 0 ? void 0 : _props$metricValues.filter(function (metricValue) {
        return metricValue.target != null;
      }));
    });
    var vueChartSeries = computed(function () {
      var _props$solutionSeries4, _props$metricValues2;
      var periods = chartPeriods.value;
      var solutions = (_props$solutionSeries4 = props.solutionSeries) !== null && _props$solutionSeries4 !== void 0 ? _props$solutionSeries4 : [];
      if (solutions.length) {
        return solutions.map(function (solution) {
          return {
            name: solution.name,
            data: ghgMetricValuesForPeriods(solution.metricValues, periods)
          };
        });
      }
      return [{
        name: 'Annual GHG reductions',
        data: ghgMetricValuesForPeriods((_props$metricValues2 = props.metricValues) !== null && _props$metricValues2 !== void 0 ? _props$metricValues2 : [], periods)
      }];
    });
    var vueChartOptions = computed(function () {
      var labelFontSize = isCompact.value ? '8px' : '10px';
      var dataLabelFontSize = isCompact.value ? '8px' : '12px';
      return {
        chart: {
          type: 'bar',
          stacked: isStacked.value,
          toolbar: {
            show: false
          },
          width: props.width,
          height: chartHeight.value
        },
        colors: CHART_COLORS,
        title: {
          text: $i18n.t('impactGoal.overview.climateImpactModule.chartTitle'),
          align: 'center',
          style: {
            fontSize: isCompact.value ? '8px' : '14px'
          }
        },
        legend: {
          show: isStacked.value,
          position: 'bottom',
          fontSize: labelFontSize
        },
        plotOptions: {
          bar: {
            dataLabels: {
              total: {
                enabled: isStacked.value,
                style: {
                  fontSize: dataLabelFontSize
                }
              }
            }
          }
        },
        xaxis: {
          categories: chartPeriods.value,
          labels: {
            style: {
              fontSize: labelFontSize
            }
          },
          style: {
            fontSize: labelFontSize
          }
        },
        yaxis: {
          title: {
            text: $i18n.t('impactGoal.overview.climateImpactModule.chartYLabel'),
            style: {
              fontSize: labelFontSize
            }
          }
        },
        dataLabels: {
          enabled: !isStacked.value,
          style: {
            fontSize: dataLabelFontSize
          }
        },
        tooltip: {
          shared: isStacked.value,
          intersect: !isStacked.value
        }
      };
    });
    var getSvgData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _chartRef$value;
        var paper, svg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!((_chartRef$value = chartRef.value) !== null && _chartRef$value !== void 0 && _chartRef$value.chart)) {
                _context.next = 13;
                break;
              }
              _context.prev = 1;
              paper = chartRef.value.chart.paper();
              if (!(paper && paper.svg)) {
                _context.next = 8;
                break;
              }
              svg = paper.svg();
              if (!svg) {
                _context.next = 8;
                break;
              }
              svg = svg.replace('<svg', "<svg viewBox=\"0 0 ".concat(props.width, " ").concat(chartHeight.value, "\""));
              return _context.abrupt("return", svg);
            case 8:
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error('Error getting SVG:', _context.t0);
            case 13:
              return _context.abrupt("return", null);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 10]]);
      }));
      return function getSvgData() {
        return _ref2.apply(this, arguments);
      };
    }();
    expose({
      getSvgData: getSvgData
    });
    return {
      __sfc: true,
      CHART_COLORS: CHART_COLORS,
      $i18n: $i18n,
      props: props,
      isStacked: isStacked,
      isCompact: isCompact,
      chartHeight: chartHeight,
      chartRef: chartRef,
      chartPeriods: chartPeriods,
      vueChartSeries: vueChartSeries,
      vueChartOptions: vueChartOptions,
      getSvgData: getSvgData,
      VueApexCharts: VueApexCharts
    };
  }
});